import { type RouteRecordRaw } from 'vue-router'

export const NotificationsTopicsRouter: RouteRecordRaw[] = [
  {
    path: '/notificationstopics',
    component: async () => import('./NotificationsTopics.vue'),
  },
]
